import React from 'react';
import { motion } from 'framer-motion';
import { brandLogo } from '../../../data/journey';
import { predict, snak3Images } from '../../../data/snak3';
const EASE = [0.23, 1, 0.32, 1] as const;
export function PredictScreen() {
  return <div className="flex flex-1 flex-col" data-id="element-427" data-mp="1spbj8v3ktlrp">
      <motion.figure initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.3,
      ease: EASE
    }} className="relative -mx-6 -mt-3" data-id="element-428" data-mp="1nr06oclwcx5s">
        <img src={snak3Images.predict.src} alt={snak3Images.predict.alt} draggable={false} className="h-[196px] w-full select-none object-cover" data-id="element-429" data-mp="v2319a2sauug" />
        <figcaption className="absolute left-0 top-4 bg-ozGreen px-3 py-1 text-[9px] font-semibold uppercase tracking-micro text-ozNavy" data-id="element-430" data-mp="19sshiqv3r056">
          {predict.status}
        </figcaption>
        <motion.h2 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: EASE
      }} className="absolute inset-x-0 bottom-0 bg-ozNavy/85 px-6 py-3 font-display text-[27px] font-bold uppercase leading-[0.96] tracking-tight text-paper" data-id="element-431" data-mp="h8k47sh9ke9e">
          {predict.headline[0]}
          <span className="mt-0.5 block text-ozGreen" data-id="element-432" data-mp="2wq2fdd31ruhv">{predict.headline[1]}</span>
        </motion.h2>
      </motion.figure>

      <motion.p initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      delay: 0.14,
      ease: EASE
    }} className="mt-5 border-l-[3px] border-ozGreen pl-3.5 font-display text-[15.5px] italic leading-snug text-paper" data-id="element-433" data-mp="31n2qi2er7nfu">
        {predict.hypothesis}
      </motion.p>

      <p className="mt-3.5 text-[12px] leading-relaxed text-paper/65" data-id="element-434" data-mp="2ix33rm6dykfl">{predict.lead}</p>

      <ul className="mt-3 flex flex-wrap gap-1.5" data-id="element-435" data-mp="3pdf5fx8f2kfx">
        {predict.chips.map(chip => <li key={chip} className="rounded-full border border-ozGreen/50 px-2.5 py-1 text-[9.5px] font-medium text-ozGreen" data-id="element-436" data-mp="3pfsunpgf12fk">
            {chip}
          </li>)}
      </ul>

      <motion.div initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      delay: 0.24,
      ease: EASE
    }} className="mt-4 overflow-hidden rounded-xl bg-paper" data-id="element-437" data-mp="2zpjeqjzl7569">
        <div className="px-4 pt-3.5" data-id="element-438" data-mp="39oifzhi0vyj8">
          <img src={brandLogo.src} alt={brandLogo.alt} draggable={false} className="h-9 w-auto select-none object-contain object-left" data-id="element-439" data-mp="39le0vp30rids" />
          <p className="mt-2.5 text-[11px] leading-snug text-mut" data-id="element-440" data-mp="2gwozdoy1xb1i">{predict.productLine}</p>
        </div>
        <p className="mt-3 border-t border-line bg-ozMist px-4 py-2.5 text-[11px] leading-snug text-ozNavy" data-id="element-441" data-mp="2vpsii0rajwuc">
          {predict.productFrame}
        </p>
      </motion.div>

      <p className="mt-3 text-[9.5px] leading-snug text-paper/50" data-id="element-442" data-mp="235txwxpvtw7y">{predict.spc}</p>

      <div className="mt-auto pt-4" data-id="element-443" data-mp="1y78z92qa3klm">
        <p className="rounded-lg border border-dashed border-paper/20 px-3 py-2 text-[9px] leading-snug text-paper/45" data-id="element-444" data-mp="1y67jwm28cby3">
          {predict.internalNote}
        </p>
      </div>
    </div>;
}